import { ActionTypes } from './actions';
import { DataConvertor } from '@888sport/uc-sportclient-lib/dist/uc-sportclient-lib.min';
import Global from '../../global';

const /**IAppDataState*/ initialState = {
  uniqueKeyToGroupDetails: {},
  quicklinks: [],
  sports: [],
  liveEvents: [],
  openBets: [],
  sportsMap: {},
  sportGroups: {},
  eventsMap: {},
  betOffersMap: {},
  participantsMap: {},
  outcomesMap: {}
};
/**
 *
 * @param {IAppDataState} state
 * @param action
 * @return {IAppDataState}
 */
export default function reducer(state = initialState, action) {
  switch (action.type) {

    /*LOAD INITIAL DATA*/
    case ActionTypes.LOAD_SPORTGROUPS_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case ActionTypes.LOAD_OPEN_BETS_SUCCESS:
      return {
        ...state,
        openBets: action.payload
      };
    case ActionTypes.ADD_SPORTS:
      return {
        ...state,
        sportsMap: {
          ...state.sportsMap,
          ...action.payload
        }
      };
    case ActionTypes.ADD_EVENTS:
      return {
        ...state,
        eventsMap: {
          ...state.eventsMap,
          ...action.payload
        }
      };
    case ActionTypes.ADD_BET_OFFERS:
      return {
        ...state,
        betOffersMap: {
          ...state.betOffersMap,
          ...action.payload
        }
      };
    case ActionTypes.ADD_PARTICIPANTS:
      return {
        ...state,
        participantsMap: {
          ...state.participantsMap,
          ...action.payload
        }
      };
    case ActionTypes.ADD_OUTCOMES:
      return {
        ...state,
        outcomesMap: {
          ...state.outcomesMap,
          ...action.payload
        }
      };

    /*EVENT UPDATES*/
    case ActionTypes.ADD_LIVE_EVENT: {
      const { eventDetails, sport } = action.payload;
      const outcomesMap = {}, betOffersMap = {};

      if (eventDetails.mainBetOffer) {
        const newBetOffer = eventDetails.mainBetOffer;
        newBetOffer.outcomes.map((outcome) => {
          outcomesMap[outcome.id] = new DataConvertor(Global.logger).transformOutcome(outcome, newBetOffer.id);
        });
        const betOffer = new DataConvertor(Global.logger).transformBetOffer(newBetOffer);
        betOffersMap[betOffer.id] = betOffer;
      }

      return {
        ...state,
        sportsMap: {
          ...state.sportsMap,
          [sport.id]: new DataConvertor(Global.logger).transformSimpleSport(sport)
        },
        eventsMap: {
          ...state.eventsMap,
          [eventDetails.event.id]: new DataConvertor(Global.logger).transformEvent(eventDetails)
        },
        betOffersMap: {
          ...state.betOffersMap,
          ...betOffersMap
        },
        outcomesMap: {
          ...state.outcomesMap,
          ...outcomesMap
        }
      };
    }
    case ActionTypes.REMOVE_EVENT: {
      const betOfferId = state.eventsMap[action.payload].mainBetOfferId;
      const outcomeIds = betOfferId && state.betOffersMap[betOfferId] ? state.betOffersMap[betOfferId].outcomes : [];
      return {
        ...state,
        outcomesMap: {
          ...state.outcomesMap,
          ...outcomeIds.reduce((dictionary, id) => {
            dictionary[id] = undefined;
            return dictionary;
          }, {})
        },
        betOffersMap: {
          ...state.betOffersMap,
          [betOfferId]: undefined
        },
        eventsMap: {
          ...state.eventsMap,
          [action.payload]: undefined
        }
      };
    }
    case ActionTypes.UPDATE_EVENT_SCORE: {
      const { eventId, score } = action.payload;
      return {
        ...state,
        eventsMap: {
          ...state.eventsMap,
          [eventId]: {
            ...state.eventsMap[eventId],
            liveData: {
              ...state.eventsMap[eventId].liveData,
              score: score
            }
          }
        }
      };
    }
    case ActionTypes.UPDATE_EVENT_STATS: {
      const { eventId, statistics } = action.payload;
      return {
        ...state,
        eventsMap: {
          ...state.eventsMap,
          [eventId]: {
            ...state.eventsMap[eventId],
            liveData: {
              ...state.eventsMap[eventId].liveData,
              statistics: statistics
            }
          }
        }
      };
    }
    case ActionTypes.UPDATE_MATCH_CLOCK: {
      const { eventId, matchClock } = action.payload;
      return {
        ...state,
        eventsMap: {
          ...state.eventsMap,
          [eventId]: {
            ...state.eventsMap[eventId],
            liveData: {
              ...state.eventsMap[eventId].liveData,
              matchClock: matchClock
            }
          }
        }
      };
    }
    case ActionTypes.REMOVE_MATCH_CLOCK: {
      const eventId = action.payload;
      return {
        ...state,
        eventsMap: {
          ...state.eventsMap,
          [eventId]: {
            ...state.eventsMap[eventId],
            liveData: {
              ...state.eventsMap[eventId].liveData,
              matchClock: {
                ...state.eventsMap[eventId].liveData.matchClock,
                disabled: true
              }
            }
          }
        }
      };
    }

    /*BET OFFER UPDATES*/
    case ActionTypes.ADD_BET_OFFER: {
      const outcomesMap = {};
      const newBetOffer = action.payload;
      if (newBetOffer.outcomes) {
        newBetOffer.outcomes.map((outcome) => {
          outcomesMap[outcome.id] = new DataConvertor(Global.logger).transformOutcome(outcome, newBetOffer.id);
        });
      }
      const betOffer = new DataConvertor(Global.logger).transformBetOffer(action.payload);
      return {
        ...state,
        eventsMap: {
          ...state.eventsMap,
          [newBetOffer.eventId]: {
            ...state.eventsMap[newBetOffer.eventId],
            mainBetOfferId: newBetOffer.id
          }
        },
        betOffersMap: {
          ...state.betOffersMap,
          [betOffer.id]: betOffer
        },
        outcomesMap: {
          ...state.outcomesMap,
          ...outcomesMap
        }
      };
    }
    case ActionTypes.REMOVE_BET_OFFER: {
      const outcomesMap = {};
      const betOffer = state.betOffersMap[action.payload];
      if (betOffer) {
        betOffer.outcomes = betOffer.outcomes ? betOffer.outcomes.forEach(outcomeId => outcomesMap[outcomeId] = undefined) : [];
        return {
          ...state,
          eventsMap: {
            ...state.eventsMap,
            [betOffer.eventId]: {
              ...state.eventsMap[betOffer.eventId],
              mainBetOfferId: undefined
            }
          },
          betOffersMap: {
            ...state.betOffersMap,
            [betOffer.id]: undefined
          },
          outcomesMap: {
            ...state.outcomesMap,
            ...outcomesMap
          }
        };
      }
      return state;
    }
    case ActionTypes.UPDATE_BET_OFFER_STATUS: {
      const { betOfferId, suspended } = action.payload;
      return {
        ...state,
        betOffersMap: {
          ...state.betOffersMap,
          [betOfferId]: {
            ...state.betOffersMap[betOfferId],
            suspended: suspended
          }
        }
      };
    }

    /*BET OFFER ODDS UPDATES*/
    case ActionTypes.ADD_BET_OFFER_ODDS: {
      const outcomesMap = { ...state.outcomesMap };
      const betOffersMap = { ...state.betOffersMap };
      const outcomes = action.payload;

      outcomes.forEach(outcome => {
        const betOffer = betOffersMap[outcome.betOfferId];
        const isNewOutcome = !betOffer.outcomes.some(oldOutcomeId => oldOutcomeId === outcome.id);
        if (isNewOutcome) {
          betOffer.outcomes.push(outcome.id);
        }
        outcomesMap[outcome.id] = new DataConvertor(Global.logger).transformOutcome(outcome, betOffer.betOfferType.id);

        let newBetOffer = {
          ...betOffer,
          outcomes: betOffer.outcomes.map(outcomeId => outcomesMap[outcomeId])
        };
        betOffersMap[newBetOffer.id] = new DataConvertor(Global.logger).transformBetOffer(newBetOffer);
      });


      return {
        ...state,
        outcomesMap,
        betOffersMap
      };
    }
    case ActionTypes.REMOVE_BET_OFFER_ODDS: {
      const oldOutcome = state.outcomesMap[action.payload.id];
      if (oldOutcome) {
        return {
          ...state,
          outcomesMap: {
            ...state.outcomesMap,
            [oldOutcome.id]: {
              ...state.outcomesMap[oldOutcome.id],
              odds: undefined
            }
          }
        };
      }
      return state;
    }
    case ActionTypes.UPDATE_BET_OFFER_ODDS: {
      const outcome = action.payload;
      return {
        ...state,
        outcomesMap: {
          ...state.outcomesMap,
          [outcome.id]: {
            ...state.outcomesMap[outcome.id],
            odds: outcome.odds
          }
        }
      };
    }
    case ActionTypes.SET_NEW_START_DATE: {
      const { eventId, startDate } = action.payload;
      return {
        ...state,
        eventsMap: {
          ...state.eventsMap,
          [eventId]: {
            ...state.eventsMap[eventId],
            event: {
              ...state.eventsMap[eventId].event,
              start: startDate
            }
          }
        }
      };
    }
    default:
      return state;
  }
}
